import { registerPlugin } from "@capacitor/core";

export interface SaveToDownloadsPlugin {
  save(options: {
    fileName: string;
    data: string;
    mimeType: string;
  }): Promise<{
    uri: string;
    fileName: string;
  }>;
}

export const SaveToDownloads =
  registerPlugin<SaveToDownloadsPlugin>("SaveToDownloads");
